import { cn } from "@/lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Use shimmer animation instead of pulse */
  shimmer?: boolean;
}

function Skeleton({ className, shimmer = false, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        "rounded-md",
        shimmer
          ? "bg-gradient-to-r from-[#1A1A1A] via-[#252525] to-[#1A1A1A] bg-[length:200%_100%] animate-skeleton-shimmer"
          : "animate-pulse bg-muted",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
